import { type MenuProps } from "react-instantsearch/dist/es/ui/Menu";

type MenuItems = MenuProps["items"];

/**
 * Transform function used to make sure `experienceLevel` items are in the desired order.
 * Expects the values of `beginner`, `intermediate`, and `advanced`.
 */
export function transformExperienceLevelItems(items: MenuItems): MenuItems {
  const orderedItems: MenuItems = [];

  for (const item of items) {
    switch (item.value) {
      case "beginner": {
        orderedItems[0] = item;
        break;
      }

      case "intermediate": {
        orderedItems[1] = item;
        break;
      }

      case "advanced": {
        orderedItems[2] = item;
        break;
      }

      // No default
    }
  }

  return orderedItems;
}
